import CardDsl from '../CardDsl'
import { ElearningInfo } from './CourseInfo'
import CardPrice from '../CardPrice'

import Proptypes from 'prop-types'

const ElearningCard = ({
  courseInfo,
  isHighlighted,
  isCourse,
  activityPage,
  isWidget,
  externalPage,
  isBlocked,
}) => {
  return (
    <CardDsl adventure={courseInfo} isHighlighted={isHighlighted} activityPage={activityPage}>
      <ElearningInfo adventure={courseInfo} />
      <CardPrice
        adventure={courseInfo}
        type='elearning'
        isCourse={isCourse}
        isWidget={isWidget}
        activityPage={activityPage}
        isBlocked={isBlocked}
        externalPage={externalPage}
      />
    </CardDsl>
  )
}

export default ElearningCard

ElearningCard.propTypes = {
  courseInfo: Proptypes.object,
  isHighlighted: Proptypes.bool,
  isCourse: Proptypes.bool,
  activityPage: Proptypes.string,
  isWidget: Proptypes.bool,
  externalPage: Proptypes.string,
  isBlocked: Proptypes.bool,
}
